module.exports = __webpack_public_path__ + "img/myazgo2019@2x.6fb45df4.png";